// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"style_tableContainer__1lSUbznIFj4XgqAbuld-Kt","sectionHeader":"style_sectionHeader__2Grcd2ba_AZPed4DMfwYsM"};